<template lang="pug">
    div.demo-infinite-container
        a-list(max-height='500' header="課程清單" :highlight-current-row='true' :split="false" :dataSource='presentCourses' empty-text='無課程' size="small")
            a-list-item.course-block(slot="renderItem" slot-scope="item" @click.native="showCourseDetail(item)")
                course-entry-large-title(:course="item")


</template>
<script>
    import CourseEntryLargeTitle from "@/components/Element/CourseGrid/CourseEntryLargeTitle";
    import {RecycleScroller} from 'vue-virtual-scroller'

    export default {
        name: 'course-list-simplified',
        components: {CourseEntryLargeTitle, RecycleScroller},
        props: {
            presentCourses: {}
        },
        methods: {
        }
    }
</script>
<style>

.course-block{
  cursor:pointer;
}
</style>
